var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw"},attrs:{"id":"app"}},[_c('div',{staticStyle:{"display":"flex","position":"relative","width":"100vw"}},[_c('common-top-box')],1),_c('div',{staticClass:"mainBoxVue",staticStyle:{"flex":"1","overflow-y":"auto","width":"100%"}},[_c('router-view'),_c('common-bottom-box')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }